import { DatePicker, DatePickerInput, DatePickerMetaProps, Text, TextButton } from '@zillow/constellation';
import { DateTime } from 'luxon';
import React from 'react';
import { Field, FieldProps } from 'formik';
import { ITaskEditFormDisplayProps } from './TaskEditForm';
import { IEditField, IFieldName } from './formTools';
import { IOrderTaskData } from 'types/tasks';
import { EditFieldControls } from './EditFieldControls';
import { FlexGrowFormField } from './FlexGrowFormField';
import { getTaskDueDateFontColor } from './taskDueDateFontColor';

export const EditDate: React.FC<
  ITaskEditFormDisplayProps & { fieldName: keyof Pick<IOrderTaskData, 'dueDate' | 'completedAt'> }
> = ({ task, setIsEditing, fieldName }) => {
  const thisDate = task[fieldName];

  const text = (thisDate && DateTime.fromISO(thisDate).toFormat('MMM d')) ?? 'No Date';
  const fontColor = fieldName === 'dueDate' ? getTaskDueDateFontColor(thisDate) : undefined;

  return (
    <TextButton
      buttonType={'primary'}
      onClick={setIsEditing}
      disabled={!setIsEditing}
      data-test-id={`edit-${fieldName}-display`}
    >
      <Text fontColor={fontColor} fontType={'bodySmall'}>
        {text ?? 'No Date'}
      </Text>
    </TextButton>
  );
};

export const EditDateField: React.FC<IEditField & IFieldName & { disableDates?: (date: Date) => boolean }> = ({
  submitOnChange,
  fieldName,
  disableDates,
  cancel,
}) => {
  const editText = (dueDate: string) => {
    if (!dueDate) return 'No Date';
    return DateTime.fromISO(dueDate).toFormat('MM/dd/yyyy');
  };
  const onChange = (value: string, meta: DatePickerMetaProps) => {
    switch (meta.reason) {
      case 'dropdown click':
      case 'dropdown keyboard':
        return true;
      default:
        return false;
    }
  };
  return (
    <EditFieldControls fieldName={`${fieldName}Date`} cancel={cancel}>
      <Field name={`${fieldName}Date`}>
        {({ field, form }: FieldProps) => (
          <FlexGrowFormField>
            <DatePickerInput
              defaultValue={editText(field.value)}
              onChange={(value, meta) => {
                form.setFieldValue(field.name, DateTime.fromFormat(value, 'MM/dd/yyyy').toISO());
                if (onChange(value, meta)) {
                  submitOnChange && form.submitForm();
                }
              }}
              datepicker={<DatePicker disabledDates={disableDates} />}
              name={field.name}
              id={field.name}
            />
          </FlexGrowFormField>
        )}
      </Field>
    </EditFieldControls>
  );
};
